import { Icon } from '#app/components/ui/icon'
import { cn } from '#app/utils/misc'

export interface ComparisonItem {
	text: string
	type: 'positive' | 'negative'
}

export interface ComparisonListProps {
	title?: string
	items?: ComparisonItem[]
}

export function ComparisonList({
	title = 'Why choose us?',
	items = [
		{ text: "I won't make anything up", type: 'negative' },
		{ text: "I won't use AI-isms", type: 'negative' },
		{ text: 'I will use concrete, specific details', type: 'positive' },
		{ text: 'I will use the active voice', type: 'positive' },
	],
}: ComparisonListProps) {
	return (
		<section className="bg-muted/20 w-full py-16 md:py-24">
			<div className="container px-4 md:px-6">
				<div className="bg-background mx-auto max-w-3xl rounded-2xl border p-8 shadow-sm md:p-12">
					{title && <h2 className="text-title-2 mb-8 text-center">{title}</h2>}
					<div className="grid gap-4 sm:grid-cols-2">
						{items.map((item, index) => (
							<div
								key={index}
								className={cn(
									'flex items-start gap-3 rounded-lg p-3 transition-colors',
									item.type === 'positive'
										? 'bg-green-50/50 text-green-900 dark:bg-green-900/10 dark:text-green-100'
										: 'bg-red-50/50 text-red-900 dark:bg-red-900/10 dark:text-red-100',
								)}
							>
								<div className="mt-0.5 shrink-0">
									{item.type === 'positive' ? (
										<Icon
											name="check"
											className="h-5 w-5 text-green-600 dark:text-green-400"
										/>
									) : (
										<Icon
											name="cross-1"
											className="h-5 w-5 text-red-600 dark:text-red-400"
										/>
									)}
								</div>
								<span className="text-sm font-medium md:text-base">
									{item.text}
								</span>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	)
}
